import Models from '@/models/Models'
import File from '@/models/File'
import Log from '@/models/Log'
import Notification from '@/models/Notification'
import Path from '@/models/Path'
import Permission from '@/models/Permission'
import User from '@/models/User'

Vue.prototype.$models = new Vue(Models)
Vue.prototype.$models.$file = new Vue(File)
Vue.prototype.$models.$log = new Vue(Log)
Vue.prototype.$models.$notification = new Vue(Notification)
Vue.prototype.$models.$path = new Vue(Path)
Vue.prototype.$models.$permission = new Vue(Permission)
Vue.prototype.$models.$user = new Vue(User)

Vue.component('mix-layout', () => import(/* webpackChunkName: "mix-layout" */ '@/Layouts/MixLayout'))
Vue.component('auth-layout', () => import(/* webpackChunkName: "auth-layout" */ '@/Layouts/AuthLayout'))
Vue.component('web-layout', () => import(/* webpackChunkName: "web-layout" */ '@/Layouts/WebLayout'))
Vue.component('admin-layout', () => import(/* webpackChunkName: "admin-layout" */ '@/Layouts/AdminLayout'))

Vue.component('minimal-navbar', () => import(/* webpackChunkName: "minimal-navbar" */ '@/Navbars/MinimalNavbar'))
Vue.component('web-navbar', () => import(/* webpackChunkName: "web-navbar" */ '@/Navbars/WebNavbar'))
Vue.component('admin-navbar', () => import(/* webpackChunkName: "admin-navbar" */ '@/Navbars/AdminNavbar'))
Vue.component('nav-inertia-item', () => import(/* webpackChunkName: "nav-inertia-item" */ '@/Navbars/NavInertiaItem'))
Vue.component('dropdown-inertia-item', () => import(/* webpackChunkName: "dropdown-inertia-item" */ '@/Navbars/DropdownInertiaItem'))
Vue.component('navbar-nav-user', () => import(/* webpackChunkName: "navbar-nav-user" */ '@/Navbars/NavbarNavUser'))
Vue.component('nav-info-pages', () => import(/* webpackChunkName: "nav-info-pages" */ '@/Navbars/NavInfoPages'))
Vue.component('nav-item-dropdown-login', () => import(/* webpackChunkName: "nav-item-dropdown-login" */ '@/Navbars/NavItemDropdownLogin'))

Vue.component('web-footer', () => import(/* webpackChunkName: "web-footer" */ '@/Footers/WebFooter'))
Vue.component('admin-footer', () => import(/* webpackChunkName: "admin-footer" */ '@/Footers/AdminFooter'))

Vue.component('example-component', () => import(/* webpackChunkName: "example-component" */ '@/components/ExampleComponent'))
Vue.component('dropzone-component', () => import(/* webpackChunkName: "dropzone-component" */ '@/components/DropzoneComponent'))
Vue.component('json-pretty-component', () => import(/* webpackChunkName: "json-pretty-component" */ '@/components/JsonPrettyComponent'))
Vue.component('contact-form-example', () => import(/* webpackChunkName: "contact-form-example" */ '@/components/ContactFormExample'))
Vue.component('cookie-notice', () => import(/* webpackChunkName: "cookie-notice" */ '@/components/CookieNotice'))
Vue.component('busy-component', () => import(/* webpackChunkName: "busy-component" */ '@/components/BusyComponent'))

Vue.component('contact-form-data', () => import(/* webpackChunkName: "contact-form-data" */ '@/components/Contact/ContactFormData'))
Vue.component('project-contact-form-data', () => import(/* webpackChunkName: "project-contact-form-data" */ '@/components/Contact/ProjectContactFormData'))

Vue.component('ckeditor-custom', () => import(/* webpackChunkName: "ckeditor-custom" */ '@/components/editors/CKEditorCustom'))
Vue.component('ckeditor-classic', () => import(/* webpackChunkName: "ckeditor-classic" */ '@/components/editors/CKEditorClassic'))
Vue.component('ckeditor-super-build', () => import(/* webpackChunkName: "ckeditor-super-build" */ '@/components/editors/CKEditorSuperBuild'))
Vue.component('vue2editor-component', () => import(/* webpackChunkName: "vue2editor-component" */ '@/components/editors/Vue2editorComponent'))

Vue.component('generic-modal', () => import(/* webpackChunkName: "generic-modal" */ '@/components/GenericModal'))
Vue.component('generic-modal-manager', () => import(/* webpackChunkName: "generic-modal-manager" */ '@/components/GenericModalManager'))

Vue.component('mix-tables', () => import(/* webpackChunkName: "mix-tables" */ '@/Tables/MixTables'))
Vue.component('action-buttons', () => import(/* webpackChunkName: "action-buttons" */ '@/Tables/ActionButtons'))
Vue.component('users-table', () => import(/* webpackChunkName: "users-table" */ '@/Tables/UsersTable'))
Vue.component('notifications-table', () => import(/* webpackChunkName: "notifications-table" */ '@/Tables/NotificationsTable'))
Vue.component('logs-table', () => import(/* webpackChunkName: "logs-table" */ '@/Tables/LogsTable'))

Vue.component('custom-v-select', () => import(/* webpackChunkName: "custom-v-select" */ '@/Forms/CustomVSelect'))
Vue.component('select-status', () => import(/* webpackChunkName: "select-status" */ '@/Forms/SelectStatus'))
Vue.component('plane-submit', () => import(/* webpackChunkName: "plane-submit" */ '@/Forms/PlaneSubmit/PlaneSubmit'))
Vue.component('submit-form', () => import(/* webpackChunkName: "submit-form" */ '@/Forms/SubmitForm'))
Vue.component('users-form', () => import(/* webpackChunkName: "users-form" */ '@/Forms/Users/UsersForm'))
Vue.component('notifications-form', () => import(/* webpackChunkName: "notifications-form" */ '@/Forms/Notifications/NotificationsForm'))

Vue.component('grid-widget', () => import(/* webpackChunkName: "grid-widget" */ '@/Widgets/GridWidget'))
Vue.component('banners-widget', () => import(/* webpackChunkName: "banners-widget" */ '@/Widgets/BannersWidget'))

Vue.component('generic-card-a', () => import(/* webpackChunkName: "generic-card-a" */ '@/Cards/Generic/GenericCardA'))
Vue.component('generic-card-b', () => import(/* webpackChunkName: "generic-card-b" */ '@/Cards/Generic/GenericCardB'))

Vue.component('has-fluid-value', () => import(/* webpackChunkName: "has-fluid-value" */ '@/Mixins/HasFluidValue'))




Vue.component('admin-navbar2', () => import(/* webpackChunkName: "admin-navbar2" */ '@/Navbars/AdminNavbar2'))